        

var novicell = novicell || {};

novicell.customSelect = new function(){

	var self = this;

	this.init = function() {

		var selector = '.html-select',
			$select = $('.html-select + select'),
			$listItem = $(selector).find('li'),
			$selectWrapper = $(selector).parents('.select-holder');

		
		self.breakTheList();
		self.setActiveList();
		self.removeFilterPills();

		$listItem.click(function() {
		    //try{
		    //try{
		        var $this = $(this),
                    dataValue = $this.attr('data-value'),
                    $parentHtmlSelect = $this.parents(selector),
                    $parentSelect = $parentHtmlSelect.siblings('select');
		        $option = $parentSelect.children('option[value="'+dataValue+'"]');


		        // Check if its a multiple select
		        if(!$parentHtmlSelect.hasClass('multiple')) {

		            // Set the value
		            $option.prop('selected', true).change();
		        } else {

		            // Toggle selected state
		            if($option.is(':selected')) {
		                $option.prop('selected', false).change();
		            } else {
		                $option.prop('selected', true).change();
		            }
		        }
		    //}
		    //catch (e) {

		    //}
		}); 

	};

	this.setActiveList = function() {

		$('.select-filter').on('change', function() {
			var $this = $(this),
				val = [],
				$htmlSelect = $this.siblings('.html-select');

			$this.find('option:selected').each(function(i){

			    val.push({
			        title: $(this).text(), 
			        dataval:  $(this).val()
			    });
			});

			self.selectList($htmlSelect, val);

			// Special-case for the employee-navigation
			if ($this.attr('id') == "Afdelinger") {
				self.selectList($('.employee-navigation'), val);
			}

			// Check if its a multiple select and add the pills
			if($htmlSelect.hasClass('multiple')) {
				self.addFilterPills($htmlSelect, val);
			}		

		});

	};

	this.selectList = function(selector, val) {

		// Reset the select
		selector.find('li').removeClass('selected');
		// Find the selected value from options and select the list-item
		if (val != null) {

			$.each(val, function(index, value) {
				selector.find('li[data-value="'+val[index].dataval+'"]').addClass('selected');
			});		
		}

	};

	this.addFilterPills = function(selector, val) {
		var $selectedValue = selector.parents('.select-wrapper').find('.selected-value');
		// Reset the select
		$selectedValue.html('');
		// Find the selected value from options and select the list-item
		if (val != null) {

			$.each(val, function(index, value) {
				$selectedValue.append('<span class="filter-pill" data-value="'+val[index].dataval+'">'+val[index].title+'</span>');
			});		
		}
	}

	this.removeFilterPills = function() {

		$('.selected-value').on('click', '.filter-pill', function() {
			var $this = $(this),
				$select = $this.parents('.select-wrapper').find('select'),
				dataValue = $this.attr('data-value');

			$select.children('option[value="'+dataValue+'"]').prop('selected', false).change();

		});

	};

	this.hideDropdown = function(selector) {
		selector.removeClass('active-filter');
	}

	this.breakTheList = function(selector) {
		var $parentUl = $('ul.html-select'),
			itemsPerRow = 9;

		$parentUl.each(function() {
			var $this = $(this),
				$item = $this.find('li'),
				$row = $this.children('.list-wrap');


				// Add columns depending on the the itemPerRow
				var x = $item.length;
				switch (true) {

				    case (x >=9 && x < 18): {
				    	$this.addClass('two-columns');
				        break;
				    }

				    case (x >= 18): {
				    	$this.addClass('three-columns');
				        break;
				    }

				}

				self.setUlWidth($this);
		});

	}

	this.setUlWidth = function(parent) {

		// Apply the width to parent container;
		var $rowUl = parent;

		$rowUl.show();

		var totalWidth = $rowUl.outerWidth(true);
		
		$rowUl.hide();



		// Position the UL right, if the screen-width is too small for the dropdown
		var	$parent = $rowUl.parent(),
			offset = $parent.offset(),
			offsetRight = $( document ).width() - (offset.left);


		if (totalWidth > offsetRight) {
			var gap = totalWidth - offsetRight + 30;
			var offsetWidth = (offsetRight/2);

			if (offsetWidth > offset.left) {
				offsetWidth = offsetWidth + gap;
			} else {
				offsetWidth = 0;
			}

			$rowUl.css({
				'left': 'inherit',
				'right': '-' + offsetWidth + 'px'
			});
		}
	}
};


